import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import MainGame from './mainGame';
import MockupGames from './mockupGames';

export const RecommendedGames = ({recommendedGameImage} : {recommendedGameImage: string}) => {
    return (
        <Flex flexDirection='column' fontSize='10px' fontWeight='700' gridGap='6px' justifyContent='flex-start'>
            <Flex>
            <Text>Recommended Games</Text>
            </Flex>
            <Flex alignItems='center' gridGap='16px' pr='32px'>
                <MainGame recommendedGameImage={recommendedGameImage}/>
                <MockupGames />
            </Flex>
        </Flex>
    );
};

export default RecommendedGames;
